export default __webpack_public_path__ + "static/logo-24a322c01d19c3ce808c907aed039eea.png";